window.ModalVegas = {
	modal: '',
	init: ($modal) => {
		let params = $modal.data();
		this.modal = $modal;

		let option = {
			type:  $modal.data('modal') || 'bootstrap',
			target: $modal.attr('href') || $modal.data('target') || false,
		};

		option = $.extend(option, params);
		ModalVegas.scatter(option);
	},
	scatter: (option) => {
		if (option.target) {
			$.each(option, function (key, value) {
				let $element = $(option.target).find('[data-'+ key +']');

				if ($element.length) {
					let tagName = $element.prop('tagName').toLowerCase();

					if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'checkbox' || tagName === 'radio') {
						$element.val(value)
					} else {
						$element.html(value)
					}
				}
			});

			if (option.type === 'bootstrap') {
				ModalVegas.modalBootstrap(option);
			} else if(option.type === 'fancybox') {
				ModalVegas.modalFancybox(option);
			}
		}
	},
	modalBootstrap: (option) => {
		let dismiss = this.modal.attr('data-dismiss');
		if (typeof dismiss !== typeof undefined && dismiss !== false) {
			return true;
		}
		
		let $modal_close = $(option.target).find('.modal-close-block');
		if ($modal_close.length) {
			let cross = '<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve"><g><polygon style="fill:#010002;" points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254 "/></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>';
			
			$modal_close.html('<button type="button" class="modal-close white" data-dismiss="modal" aria-label="Close">' + cross + '</button>');
		}
		
		if (option.opacity && option.opacity !== '' && option.opacity !== 'undefined') {
			$('body').addClass('modal-opacity-' + option.opacity);
		}
		
		$(option.target).modal('show');
	},
	modalFancybox: (option) => {
		let defaults = [{
			src: option.target
		}];

		if (option.fancy) {
			defaults[0] = $.extend(option.fancy, defaults[0]);
		}

		$.fancybox.open(defaults);
	}
};
